module.exports = __webpack_public_path__ + "static/media/loader.673e851f.svg";